// @module C3.PDPSerialLotFunctionality.SerialLotCartConfirmation
define('C3.PDPSerialLotFunctionality.SerialLotCartConfirmation.View'
,   [
        'seriallot_cart_confirmation.tpl'
    ,   'Utils'
    ,   'Backbone'
    ,   'Transaction.Line.Views.Price.View'
    ,   'Transaction.Line.Views.Options.Selected.View'
    ,   'ProductLine.Sku.View'
    ,   'Backbone.View'
    ]
, function (
        seriallot_cart_confirmation_tpl
    ,   Utils
    ,   Backbone
    ,   TransactionLineViewsPriceView
    ,   TransactionLineViewsOptionsSelectedView
    ,   ProductLineSkuView
    ,   BackboneView
)
{
    'use strict';

    // @class C3.PDPSerialLotFunctionality.SerialLotCartConfirmation.View @extends Backbone.View
    return BackboneView.extend({

        template: seriallot_cart_confirmation_tpl

    ,   title: Utils.translate('Added to Bag')

    ,   page_header: Utils.translate('Added to Bag')

    ,   attributes: {
            id: 'SerialLot.Cart.Confirmation.View',
            class: 'add-to-cart-confirmation-modal shopping-cart-modal'
        }

    ,   events: {
            'click [data-action="take-to-cart"]': 'goToCart'
        }

    ,   initialize: function(options) {
            this.application = options.application;
            this.model = options.model;
            this.conditionData = options.conditionData || {};
        }

    ,   goToCart: function(e) {
            e.preventDefault();
            this.$containerModal.modal('hide');
            Backbone.history.navigate('cart', { trigger: true });
        }

    ,   childViews: {
            'Line.Price': function() {
                return new TransactionLineViewsPriceView({
                    model: this.model
                });
            }
        ,   'Line.SelectedOptions': function() {
                return new TransactionLineViewsOptionsSelectedView({
                    model: this.model
                });
            }
        ,   'Line.Sku': function() {
                return new ProductLineSkuView({
                    model: this.model
                });
            }
        }

    ,   getContext: function() {
            var item = this.model.get('item');
            var conditionData = this.conditionData;

            return {
                model: this.model,
                thumbnail: this.model.getThumbnail(),
                showQuantity: item.get('_itemType') !== 'GiftCert' && this.model.get('quantity') > 0,
                itemName: item.get('_name', true),
                isPhoneDevice: Utils.isPhoneDevice(),
                // Condition labels from conditionData
                cosmeticLabel: conditionData.cosmetic || '',
                functionalLabel: conditionData.functional || '',
                disposableLabel: conditionData.disposable || '',
                lotPrice: conditionData.price ? Utils.formatCurrency(conditionData.price) : '',
                lotImageUrl: conditionData.imgurl || ''
            };
        }
    });
});
